import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// This HOC is here only temporarily as React router v6 doesn't support withRouter anymore
// TODO remove after components are converted to functional components and hooks are available
const withRouter = Component => props => {
  const navigate = useNavigate();
  const location = useLocation();
  const routeParams = useParams();

  return (
    <Component
      {...props}
      location={location}
      navigate={navigate}
      routeParams={routeParams}
    />
  );
};

export default withRouter;
